import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "container col-sm-6",
  style: {"float":"none"}
}
const _hoisted_2 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row col-12 text-left" }
const _hoisted_5 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_6 = { class: "row col-12 text-left" }
const _hoisted_7 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_8 = { class: "row col-12 text-left" }
const _hoisted_9 = { class: "row col-12 text-left" }
const _hoisted_10 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_11 = { class: "row col-12 text-left" }
const _hoisted_12 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_13 = { class: "row col-12 text-left" }
const _hoisted_14 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row col-12 text-left" }
const _hoisted_17 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_18 = { class: "row col-12 text-left" }
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_21 = { class: "row col-12 text-left" }
const _hoisted_22 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_23 = {
  key: 0,
  class: "row col-12 text-left"
}
const _hoisted_24 = {
  key: 0,
  class: "col-4"
}
const _hoisted_25 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "row col-12 text-left" }
const _hoisted_28 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_29 = { class: "row col-12 text-left" }
const _hoisted_30 = { class: "row col-12 text-left" }
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_33 = { class: "row col-12 text-left" }
const _hoisted_34 = { class: "row col-12 text-left" }
const _hoisted_35 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_36 = { class: "row col-12 text-left" }
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_39 = { class: "row col-12 text-left" }
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_42 = { class: "row col-12 text-left" }
const _hoisted_43 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_44 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_45 = { class: "container" }
const _hoisted_46 = { class: "row col-12 text-left" }
const _hoisted_47 = { class: "border border-1 col-8" }
const _hoisted_48 = { class: "col-6" }
const _hoisted_49 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_50 = { class: "row col-12 text-left" }
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_53 = { class: "row col-12 text-left" }
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_56 = { class: "row col-12 text-left" }
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_59 = { class: "row col-12 text-left" }
const _hoisted_60 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_61 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_62 = { class: "container" }
const _hoisted_63 = { class: "row col-12 text-left" }
const _hoisted_64 = { class: "row col-12 text-left" }
const _hoisted_65 = { class: "border border-1 col-8" }
const _hoisted_66 = { class: "col-6" }
const _hoisted_67 = { class: "row col-12 text-left" }
const _hoisted_68 = { class: "border border-1 col-8" }
const _hoisted_69 = { class: "col-6" }
const _hoisted_70 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_71 = { class: "container" }
const _hoisted_72 = { class: "row col-12 text-left" }
const _hoisted_73 = ["value"]
const _hoisted_74 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_75 = { class: "row col-12 text-left" }
const _hoisted_76 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_77 = { class: "row col-12 text-left" }
const _hoisted_78 = { class: "border border-1 col-8" }
const _hoisted_79 = { class: "col-6" }
const _hoisted_80 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_81 = { class: "row col-12 text-left" }
const _hoisted_82 = { class: "border border-1 col-8" }
const _hoisted_83 = { class: "col-6" }
const _hoisted_84 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_85 = { class: "row col-12 text-left" }
const _hoisted_86 = ["value"]
const _hoisted_87 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_88 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "h1" }, "Update Profile", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("span", { class: "col-12 fw-bold h4 mb-2" }, "Personal Information")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "col-3" }, " First Name ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.FirstName) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.FirstName]
            ]),
            (!$setup.formData.FirstName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "col-3" }, " Last Name ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.LastName) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.LastName]
            ]),
            (!$setup.formData.LastName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "col-3" }, " Previously Known As", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.PreviouslyKnownAs) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PreviouslyKnownAs]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "col-3" }, " Mobile ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.MobileNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.MobileNumber]
            ]),
            (!$setup.formData.MobileNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "col-3" }, " Email ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.Email) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.Email]
            ]),
            (!$setup.formData.Email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "col-3" }, " Phone2 ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.Phone2) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.Phone2]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("span", { class: "h4 mb-2 fw-bold" }, "Work Information")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "col-3" }, " SIA No. ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formData.SiabadageNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.SiabadageNumber]
            ]),
            (!$setup.formData.SiabadageNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "col-3" }, " SIA Exp. Date ", -1)),
            _createElementVNode("span", _hoisted_19, " (" + _toDisplayString($setup.formatDateForDisplay($setup.formData.SiaExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              class: "col-4",
              type: "date",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formData.SiaExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.SiaExpiryDate]
            ]),
            (!$setup.formData.SiaExpiryDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "col-3" }, " NI/UTR ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formData.Ninumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.Ninumber]
            ]),
            (!$setup.formData.Ninumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, "*"))
              : _createCommentVNode("", true)
          ]),
          (!$setup.isUkNational)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "col-3" }, " Share Code ", -1)),
                ($setup.formData.ShareCodeUpdatedAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, " (last updated " + _toDisplayString($setup.formatDateForDisplay($setup.formData.ShareCodeUpdatedAt)) + ")", 1))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass($setup.formData.ShareCodeUpdatedAt ? 'col-4' : 'col-8'),
                  type: "input",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formData.ShareCode) = $event)),
                  maxlength: "20",
                  placeholder: "e.g. W4B 7XR 2KP"
                }, null, 2), [
                  [_vModelText, $setup.formData.ShareCode]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Address Information")
          ], -1)),
          _createElementVNode("div", _hoisted_27, [
            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "col-3" }, " House Name/Number", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.formData.HouseNameNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.HouseNameNumber]
            ]),
            (!$setup.formData.HouseNameNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[46] || (_cache[46] = _createElementVNode("span", { class: "col-3" }, " Street", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.formData.StreetAdress) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.StreetAdress]
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "col-3" }, " City ", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.selectedCityName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cityList, (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city.cityId,
                  value: city.name
                }, _toDisplayString(city.name), 9, _hoisted_31))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedCityName]
            ]),
            (!$setup.selectedCityName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[48] || (_cache[48] = _createElementVNode("span", { class: "col-3" }, " County ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.formData.County) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.County]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "col-3" }, " PostCode ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.formData.PostCode) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PostCode]
            ]),
            (!$setup.formData.PostCode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[50] || (_cache[50] = _createElementVNode("span", { class: "col-3" }, " Country ", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.selectedAddressCountry) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_37))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedAddressCountry]
            ]),
            (!$setup.selectedAddressCountry)
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "col-3" }, " Conveyance ", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.selectedConveyanceName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conveyanceListArray, (conveyance) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: conveyance.id,
                  value: conveyance.name
                }, _toDisplayString(conveyance.name), 9, _hoisted_40))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedConveyanceName]
            ]),
            (!$setup.selectedConveyanceName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_41, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[52] || (_cache[52] = _createElementVNode("span", { class: "col-3" }, " Emergency Contact", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.formData.NextOfKin) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.NextOfKin]
            ]),
            (!$setup.formData.NextOfKin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Origin Information")
          ], -1)),
          _createElementVNode("div", _hoisted_46, [
            _cache[54] || (_cache[54] = _createElementVNode("span", { class: "col-3" }, " DateOfBirth ", -1)),
            _createElementVNode("span", _hoisted_47, [
              _createElementVNode("span", _hoisted_48, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.DateOfBirth)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.formData.DateOfBirth) = $event))
              }, null, 512), [
                [_vModelText, $setup.formData.DateOfBirth]
              ])
            ]),
            (!$setup.formData.DateOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_49, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _cache[55] || (_cache[55] = _createElementVNode("span", { class: "col-3" }, " Country Of Birth ", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.selectedCountryOfBirth) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_51))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedCountryOfBirth]
            ]),
            (!$setup.selectedCountryOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_52, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _cache[56] || (_cache[56] = _createElementVNode("span", { class: "col-3" }, " Nationality", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.selectedNationality) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_54))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedNationality]
            ]),
            (!$setup.selectedNationality)
              ? (_openBlock(), _createElementBlock("span", _hoisted_55, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "col-3" }, " Gender", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.selectedGenderType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.genderList, (g) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: g.id,
                  value: g.name
                }, _toDisplayString(g.name), 9, _hoisted_57))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedGenderType]
            ]),
            (!$setup.selectedGenderType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_58, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "col-3" }, " Place Of Birth ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.formData.PlaceOfBirth) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PlaceOfBirth]
            ]),
            (!$setup.formData.PlaceOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_60, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Passport Information")
          ], -1)),
          _createElementVNode("div", _hoisted_63, [
            _cache[60] || (_cache[60] = _createElementVNode("span", { class: "col-3" }, " Passport No", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-6",
              type: "text",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.formData.PassportNo) = $event))
            }, null, 512), [
              [_vModelText, $setup.formData.PassportNo]
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _cache[61] || (_cache[61] = _createElementVNode("span", { class: "col-3" }, " Expires On ", -1)),
            _createElementVNode("span", _hoisted_65, [
              _createElementVNode("span", _hoisted_66, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.PassportExpiryDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.formData.PassportExpiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.formData.PassportExpiryDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _cache[62] || (_cache[62] = _createElementVNode("span", { class: "col-3" }, " Visa Expires ", -1)),
            _createElementVNode("span", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, "(" + _toDisplayString($setup.formatDateForDisplay($setup.formData.VisaExpiryDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.formData.VisaExpiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.formData.VisaExpiryDate]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _cache[70] || (_cache[70] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Identity Document Information(OPTIONAL)")
          ], -1)),
          _createElementVNode("div", _hoisted_72, [
            _cache[64] || (_cache[64] = _createElementVNode("span", { class: "col-3" }, " ID Document", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.selectedIdDocumentName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentTypesList, (dt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: dt.id,
                  value: dt.name
                }, _toDisplayString(dt.name), 9, _hoisted_73))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedIdDocumentName]
            ]),
            (!$setup.selectedIdDocumentName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_74, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _cache[65] || (_cache[65] = _createElementVNode("span", { class: "col-3" }, " Number ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.idDocumentNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.idDocumentNumber]
            ]),
            (!$setup.idDocumentNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_76, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_77, [
            _cache[66] || (_cache[66] = _createElementVNode("span", { class: "col-3" }, " Issue Date ", -1)),
            _createElementVNode("span", _hoisted_78, [
              _createElementVNode("span", _hoisted_79, "(" + _toDisplayString($setup.formatDateForDisplay($setup.idDocumentIssueDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.idDocumentIssueDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.idDocumentIssueDate]
              ])
            ]),
            (!$setup.idDocumentIssueDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_80, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_81, [
            _cache[67] || (_cache[67] = _createElementVNode("span", { class: "col-3" }, " Expiry Date ", -1)),
            _createElementVNode("span", _hoisted_82, [
              _createElementVNode("span", _hoisted_83, "(" + _toDisplayString($setup.formatDateForDisplay($setup.idDocumentExpiryDate)) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.idDocumentExpiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.idDocumentExpiryDate]
              ])
            ]),
            (!$setup.idDocumentExpiryDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_84, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_85, [
            _cache[68] || (_cache[68] = _createElementVNode("span", { class: "col-3" }, " Issued By ", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.selectedIdDocumentCountryOfIssue) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id,
                  value: n.name
                }, _toDisplayString(n.name), 9, _hoisted_86))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedIdDocumentCountryOfIssue]
            ]),
            (!$setup.selectedIdDocumentCountryOfIssue)
              ? (_openBlock(), _createElementBlock("span", _hoisted_87, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["row col-12 text-left", {'border-2': true, 'bg-warning':!$setup.isPrivacyPolicyAgreed}])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "col-2 text-left",
              type: "checkbox",
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.isPrivacyPolicyAgreed) = $event))
            }, null, 512), [
              [_vModelCheckbox, $setup.isPrivacyPolicyAgreed]
            ]),
            _cache[69] || (_cache[69] = _createElementVNode("span", { class: "col-10" }, [
              _createTextVNode(" By Submitting this form you agree to our "),
              _createElementVNode("a", {
                href: "https://eaglesecurityltd.co.uk/privacy-policy-2",
                target: "blank"
              }, "Privacy Policy")
            ], -1))
          ], 2)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($setup.UpdateOfficer && $setup.UpdateOfficer(...args))),
        disabled: $setup.isSaving
      }, _toDisplayString($setup.isSaving ? 'Saving...' : 'Save'), 9, _hoisted_88)
    ])
  ], 64))
}